export type PlanoTipo = 'mensal' | 'anual';

export type SubscriptionStatus =
  | 'trial'
  | 'active'
  | 'past_due'
  | 'unpaid'
  | 'canceled'
  | 'expired';

export interface AssinaturaResponse {
  id: string;
  status: SubscriptionStatus;
  plano: PlanoTipo | null;
  diasRestantesTrial: number;
  dataInicioTrial: string;
  dataFimTrial: string;
  vigenciaInicio: string | null;
  vigenciaFim: string | null;
  cancelarAoFimDoPeriodo: boolean;
  planoAgendado?: string | null;
  downgradeAgendado?: boolean;
  dataEfetivacaoDowngrade?: string | null;
  emGracePeriod: boolean;
  diasRestantesGracePeriod: number | null;
  podeAcessar: boolean;
  stripeCustomerId?: string | null;
  stripeSubscriptionId?: string | null;
}

export interface StripeAuditResponse {
  ambiente: string;
  apiStripeConectada: boolean;
  chavesValidas: boolean;
  webhookSecretConfigurado: boolean;
  precoMensalValido: boolean;
  precoMensalId: string;
  precoMensalValor?: number | null;
  precoAnualValido: boolean;
  precoAnualId: string;
  precoAnualValor?: number | null;
  customerPortalHabilitado: boolean;
  erros: string[];
  alertas: string[];
  auditadoEm: string;
}

export interface DowngradePlanoResponse {
  success: boolean;
  message: string;
  novoPlano: string;
  efetivacao?: string | null;
}

export interface CancelarAssinaturaRequest {
  motivo?: string;
}

export interface CancelarAssinaturaResponse {
  success: boolean;
  message: string;
  tipo: string;
  efetivacao?: string | null;
  reembolsoProcessado: boolean;
}

export interface CheckoutSessionRequest {
  plano: PlanoTipo;
  cpfCnpj?: string;
  razaoSocial?: string;
  successUrl?: string;
  cancelUrl?: string;
}

export interface CheckoutSessionResponse {
  sessionId: string;
  checkoutUrl: string;
}

export interface CustomerPortalRequest {
  returnUrl?: string;
}

export interface CustomerPortalResponse {
  portalUrl: string;
}

export interface UpgradeAnualResponse {
  success: boolean;
  message: string;
  plano: string;
  vigenciaFim?: string | null;
}

export interface ReativarAssinaturaResponse {
  success: boolean;
  message: string;
}

export interface SubscriptionActivatedPayload {
  organizationId: string;
  status: SubscriptionStatus | string;
  plano?: PlanoTipo | string | null;
  vigenciaFim?: string | null;
}

export interface SubscriptionActivatedEvent {
  type: 'subscription:activated';
  payload: SubscriptionActivatedPayload;
}

export interface ApiErrorResponse {
  success: boolean;
  errorCode?: string | null;
  message?: string | null;
  data?: any;
  errors?: any;
}

export const SubscriptionErrorCodes = {
  ALREADY_SUBSCRIBED_TO_THIS_PLAN: 'ALREADY_SUBSCRIBED_TO_THIS_PLAN',
  PLAN_MIGRATION_REQUIRED: 'PLAN_MIGRATION_REQUIRED',
  SUBSCRIPTION_PAST_DUE: 'SUBSCRIPTION_PAST_DUE',
  ACTIVE_SUBSCRIPTION_EXISTS: 'ACTIVE_SUBSCRIPTION_EXISTS'
} as const;

